import { useMediaQuery } from '@react-hook/media-query';
import { useEffect, useState } from 'react';

import useGetUserAgent from './useGetUserAgent';

const desktopQuery = '(min-width: 1024px)';

const useIsDesktopSize = () => {
  const isMediaDesktop = useMediaQuery(desktopQuery);
  const { isDesktop } = useGetUserAgent();
  const [isDeviceDesktop, setIsDeviceDesktop] = useState(isDesktop);
  useEffect(() => {
    setIsDeviceDesktop(isMediaDesktop);
  }, [isMediaDesktop]);
  return isDeviceDesktop;
};

export default useIsDesktopSize;
